module.exports = __webpack_public_path__ + "static/cube4-8f24c2ec5a9155d0f458b4651164665b.svg";